import { getCompanyInfo } from "@/model/CompanyInfo";

export const CUSTOM_TENOR_SANS_FONT_COMPANY_ID = [920];
export const CUSTOM_POPPINS_FONT_COMPANY_ID = [2208, 2209, 2958, 2959, 2960, 2980, 2981, 2982, 2991, 2992, 2994, 2995, 2996];

export const getFontFaceList = (fontFaceList: any[]) => {
  const customFontFaceList = [];
  const companyInfo = getCompanyInfo();

  if (CUSTOM_TENOR_SANS_FONT_COMPANY_ID.includes(companyInfo.id || 0)) {
    customFontFaceList.push({
      name: 'Tenor Sans',
      value: 'Tenor Sans, sans-serif',
    });
  }

  if (CUSTOM_POPPINS_FONT_COMPANY_ID.includes(companyInfo.id || 0)) {
    customFontFaceList.push({
      name: 'Poppins',
      value: 'Poppins, sans-serif',
    });
  }

  return [
    ...customFontFaceList,
    ...fontFaceList,
  ];
};
